var path = '/app/components/emptible/emptible.html';
var html = "<div class=ng-cloak ng-switch=\"$ctrl.entities.length || 0\"> <br/> <div class=\"well text-center\" ng-switch-when=0 data-translate>entity.empty</div> <div ng-switch-default> <ng-transclude></ng-transclude> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;